import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff, Check } from "lucide-react";

export function PasswordFields({ value, onChange, prefix = "pw" }) {
  const [show, setShow] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const longEnough = value.password.length >= 8;
  const match = value.confirm.length > 0 && value.password === value.confirm;
  return (
    <>
      <div className="space-y-1.5">
        <div className="flex items-center justify-between"><Label htmlFor={`${prefix}-password`}>New password</Label>
          <button type="button" onClick={() => setShow((s) => !s)} className="text-xs text-slate-500 hover:text-slate-800 inline-flex items-center gap-1" data-testid={`${prefix}-toggle-visibility`}>
            {show ? <><EyeOff className="h-3.5 w-3.5" /> Hide</> : <><Eye className="h-3.5 w-3.5" /> Show</>}
          </button></div>
        <Input id={`${prefix}-password`} type={show ? "text" : "password"} required minLength={8} value={value.password} onChange={(e) => set("password", e.target.value)} placeholder="At least 8 characters" className="h-11" data-testid={`${prefix}-password`} autoComplete="new-password" />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${prefix}-confirm`}>Confirm password</Label>
        <Input id={`${prefix}-confirm`} type={show ? "text" : "password"} required value={value.confirm} onChange={(e) => set("confirm", e.target.value)} placeholder="Type it again" className="h-11" data-testid={`${prefix}-confirm`} autoComplete="new-password" />
      </div>
      <ul className="text-xs text-slate-500 space-y-1" data-testid={`${prefix}-rules`}>
        <li className={`flex items-center gap-1.5 ${longEnough ? "text-emerald-600" : ""}`}><Check className={`h-3.5 w-3.5 ${longEnough ? "" : "opacity-30"}`} /> At least 8 characters</li>
        <li className={`flex items-center gap-1.5 ${match ? "text-emerald-600" : ""}`}><Check className={`h-3.5 w-3.5 ${match ? "" : "opacity-30"}`} /> Both passwords match</li>
      </ul>
    </>
  );
}
